import styled, { css } from 'styled-components';

interface OrbWrapperProps {
  $width: number;
  $height: number;
  $interactive: boolean;
}

export const OrbWrapper = styled.div<OrbWrapperProps>`
  position: relative;
  display: block;
  line-height: 0;
  width: ${({ $width }) => `${$width}px`};
  height: ${({ $height }) => `${$height}px`};
  user-select: none;
  -webkit-tap-highlight-color: transparent;
  ${({ $interactive }) =>
    $interactive &&
    css`
      cursor: pointer;
    `}
`;

export const OrbCanvas = styled.canvas<{ $isDark: boolean }>`
  display: block;
  width: 100%;
  height: 100%;
  filter: drop-shadow(
    0 0 24px
      ${({ $isDark }) => ($isDark ? 'rgba(120, 130, 230, 0.22)' : 'rgba(75, 73, 218, 0.18)')}
  );
`;
